import { Card, Box, Icon, Text, SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import './Panels.css';
import click from './sounds/shortclick.mp3';
//import { Device } from "./Device.jsx";
import { FaCircle, FaCheckCircle, FaExclamationCircle, FaSpinner } from 'react-icons/fa';
import groundFloor from './images/FuTipMap_720px.png';

// Constants
const FLOOR_WIDTH = 730;

export default function PowerMeterPanels() {
    const tindex = useRef(1);
    const [dev, setDev] = useState([]);
    const [displayDev, setDisplayDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [selectedType, setSelectedType] = useState(1);
    const [hoveredDeviceId, setHoveredDeviceId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [pins_g, setPins_g] = useState([]);
    const isInitialLoad = useRef(true);

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    // Create a connection to the hub
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    function hexToFloat(hexString) {
        // Remove any '0x' prefix if present
        hexString = hexString.replace(/^0x/, '');

        // Parse the hex string to a 32-bit unsigned integer
        const intValue = parseInt(hexString, 16);

        // Handle NaN cases
        if (isNaN(intValue)) {
            return NaN;
        }

        // Create a DataView to handle the binary conversion
        const buffer = new ArrayBuffer(4);
        const view = new DataView(buffer);

        // Set the 32-bit value
        view.setUint32(0, intValue);

        // Get the value back as a 32-bit float
        return view.getFloat32(0);
    }

    const handleCellEnter = (deviceId) => {
        setHoveredDeviceId(deviceId);
        playClickSound();
    };

    const handleCellLeave = () => {
        setHoveredDeviceId(null);
    };

    const FloorplanImage = ({ src, alt }) => (
        <div className="estate-image" align-items="center">
            <img src={src} alt={alt} width={FLOOR_WIDTH} />
        </div>
    );

    const PinIcon = ({ id, x, y, isHovered, type }) => {
        return (
            <div style={{
                position: "absolute",
                left: `${x}px`,
                top: `${y}px`,
                transform: "translate(-50%, -50%)",
                zIndex: 5,
                cursor: "pointer"
            }}
                onMouseEnter={() => handleCellEnter(id)}
                onMouseLeave={handleCellLeave}
            >
                {(isHovered || type) && (
                    <div style={{
                        position: "absolute",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255, 215, 0, 0.3)",
                        border: "2px solid rgba(255, 215, 0, 0.8)",
                        animation: "pulse 1.5s infinite",
                        transform: "translate(-50%, -50%)",
                    }} />
                )}

                <div style={{
                    position: "absolute",
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: isHovered ? "yellow" : "red",
                    transform: "translate(-50%, -50%)",
                    transition: "all 0.3s ease",
                    boxShadow: isHovered ? "0 0 10px gold" : "none"
                }} />
            </div>
        );
    };

    const ImageWithPins = ({ pins, hoveredDeviceId }) => (
        <div>
            {pins.map((pin) => (
                <PinIcon
                    key={pin.id}
                    id={pin.id}
                    x={pin.x}
                    y={pin.y}
                    isHovered={hoveredDeviceId === pin.id}
                    type={pin.type === 0 ? false : true}
                />
            ))}
        </div>
    );

    function formatNumber(num) {
        // Convert to number, round it, then format with commas
        return Math.round(Number(num)).toLocaleString('en-US');
    }

    const DeviceCell = ({ device, isHovered }) => {
        const cellStyle = {
            fontSize: "16px",
            overflow: "hidden",
            color: "#f7f4ef",
            backgroundColor: isHovered ? "#1a237e" : "#525252",
            transition: "all 0.3s ease",
            //border: isHovered ? "2px solid gold" : "2px solid transparent",
            borderRadius: "4px",
            padding: "8px",
            margin: "4px",
            boxShadow: isHovered ? "0 0 10px rgba(255,215,0,0.5)" : "none"
        };

        return (
            <td
                key={device.id}
                className="powermetercellstyle"
                style={cellStyle}
                onMouseEnter={() => handleCellEnter(device.id)}
                onMouseLeave={handleCellLeave}
            >
                <table>
                    <tbody>
                        <tr style={{ fontSize: "22px", fontWeight: "bold", height: "78px" }}>{device.label}</tr>
                        <tr>
                            <div style={{
                                fontSize: "24px",
                                overflow: "hidden",
                                fontWeight: "bold",
                                color: isHovered ? "gold" : "#4caf50"
                            }}>
                                <div
                                    className="meterstatusstyle"
                                    style={{
                                        marginTop: "auto",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        color: "#f5f0e9",
                                        backgroundColor: "#1976d2",
                                        borderRadius: "4px",
                                        padding: "4px",
                                        boxShadow: isHovered ? "0 0 8px rgba(255,215,0,0.7)" : "none"
                                    }}
                                >
                                    {/*{device.status} kWh*/}
                                    {formatNumber(device.status)}kWh
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </td>
        );
    };

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    mapx: item.mapx === null ? null : item.mapx * FLOOR_WIDTH / 1024,
                    mapy: item.mapy === null ? null : item.mapy * FLOOR_WIDTH / 1024,
                    type: item.type,
                    buildingId: item.buildingId,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    active: item.active,
                    unit: item.unit
                }));

                const scaledPin_2 = deviceDetails
                    .filter(device => device.data_type === 11)
                    .filter(device => device.mapx !== null && device.mapy !== null)
                    .map(device => ({ ...device, x: device.mapx, y: device.mapy }));

                setPins_g(scaledPin_2);
                setDev(deviceDetails);

                const filteredDev = deviceDetails.filter(d => d.data_type === 11 && d.active === 1);
                setDisplayDev(filteredDev);
                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };

        getData();
    }, [retry]);

    useEffect(() => {
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: { 'Content-Type': 'application/json' }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    mapx: item.mapx === null ? null : item.mapx * FLOOR_WIDTH / 1024,
                    mapy: item.mapy === null ? null : item.mapy * FLOOR_WIDTH / 1024,
                    type: item.type,
                    buildingId: item.buildingId,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    active: item.active
                }));

                const scaledPin_2 = deviceDetails
                    .filter(device => device.data_type === 11)
                    .filter(device => device.mapx !== null && device.mapy !== null)
                    .map(device => ({ ...device, x: device.mapx, y: device.mapy }));

                setPins_g(scaledPin_2);
                setDev(deviceDetails);

                const filteredDev = deviceDetails.filter(d => d.data_type === 11 && d.active === 1);
                setDisplayDev(filteredDev);

                if (isInitialLoad.current) {
                    isInitialLoad.current = false;
                }
            } catch (error) {
                console.error(error);
            }
        };

        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        connection.on("ReceiveDeviceData", () => {
            console.log("Updating....");
            getData();
        });

        return () => {
            connection.off("ReceiveDeviceData");
        };
    }, []);

    useEffect(() => {
        console.log("DisplayDev updated:", displayDev);
    }, [displayDev]);

    const DeviceList = () => {
        // Calculate totals for each building
        const building1Total = displayDev
            .filter(dev_item => dev_item.buildingId === 1)
            .reduce((sum, device) => {
                const value = parseFloat(device.status);
                return sum + (isNaN(value) ? 0 : value);
            }, 0);

        const building2Total = displayDev
            .filter(dev_item => dev_item.buildingId === 2)
            .reduce((sum, device) => {
                const value = parseFloat(device.status);
                return sum + (isNaN(value) ? 0 : value);
            }, 0);

        const totalRowStyle = {
            fontSize: "20px",
            fontWeight: "bold",
            color: "#ffffff",
            backgroundColor: "#333333",
            borderRadius: "8px",
            padding: "8px",
            marginTop: "8px",
            textAlign: "right"
        };

        return (
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '4px' }}>
                <tbody>
                    {/* Building 1 - Top row */}
                    <tr>
                        <td colSpan="2" style={{ verticalAlign: 'top' }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                                backgroundColor: '#888888',
                                borderRadius: '12px',
                                padding: '4px',
                                margin: '4px 0'
                            }}>
                                <h3 style={{
                                    width: '100%',
                                    padding: '8px',
                                    margin: 0,
                                    color: '#ffffff',
                                    fontSize: '24px',
                                    fontWeight: '600',
                                    backgroundColor: '#ff7f27',
                                    borderRadius: '8px'
                                }}>班蝶樓</h3>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '4px',
                                }}>
                                    <td
                                        className="powermetercellstyle"
                                        style={{
                                            fontSize: "16px",
                                            overflow: "hidden",
                                            color: "#f7f4ef",
                                            backgroundColor:  "#525252",
                                            transition: "all 0.3s ease",
                                            //border: isHovered ? "2px solid gold" : "2px solid transparent",
                                            borderRadius: "4px",
                                            padding: "8px",
                                            margin: "4px",
                                            boxShadow: "none"
                                        }}
                                    >
                                        <table>
                                            <tbody>
                                                <tr style={{ fontSize: "22px", fontWeight: "bold", height: "78px" }}>#1升降機</tr>
                                                <tr>
                                                    <div style={{
                                                        fontSize: "24px",
                                                        overflow: "hidden",
                                                        fontWeight: "bold",
                                                        color: "#4caf50"
                                                    }}>
                                                        <div
                                                            className="meterstatusstyle"
                                                            style={{
                                                                marginTop: "auto",
                                                                textAlign: "center",
                                                                fontWeight: "bold",
                                                                color: "#f5f0e9",
                                                                backgroundColor: "#1976d2",
                                                                borderRadius: "4px",
                                                                padding: "4px",
                                                                boxShadow: "none"
                                                            }}
                                                        >
                                                            {/*{device.status} kWh*/}
                                                            --- kWh
                                                        </div>
                                                    </div>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </div>
                                <td
                                    className="powermetercellstyle"
                                    style={{
                                        fontSize: "16px",
                                        overflow: "hidden",
                                        color: "#f7f4ef",
                                        backgroundColor: "#525252",
                                        transition: "all 0.3s ease",
                                        //border: isHovered ? "2px solid gold" : "2px solid transparent",
                                        borderRadius: "4px",
                                        padding: "8px",
                                        margin: "4px",
                                        boxShadow: "none"
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr style={{ fontSize: "22px", fontWeight: "bold", height: "78px" }}>#2升降機</tr>
                                            <tr>
                                                <div style={{
                                                    fontSize: "24px",
                                                    overflow: "hidden",
                                                    fontWeight: "bold",
                                                    color: "#4caf50"
                                                }}>
                                                    <div
                                                        className="meterstatusstyle"
                                                        style={{
                                                            marginTop: "auto",
                                                            textAlign: "center",
                                                            fontWeight: "bold",
                                                            color: "#f5f0e9",
                                                            backgroundColor: "#1976d2",
                                                            borderRadius: "4px",
                                                            padding: "4px",
                                                            boxShadow:  "none"
                                                        }}
                                                    >
                                                        {/*{device.status} kWh*/}
                                                        --- kWh
                                                    </div>
                                                </div>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td
                                    className="powermetercellstyle"
                                    style={{
                                        fontSize: "16px",
                                        overflow: "hidden",
                                        color: "#f7f4ef",
                                        backgroundColor: "#525252",
                                        transition: "all 0.3s ease",
                                        //border: isHovered ? "2px solid gold" : "2px solid transparent",
                                        borderRadius: "4px",
                                        padding: "8px",
                                        margin: "4px",
                                        boxShadow: "none"
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr style={{ fontSize: "22px", fontWeight: "bold", height: "78px" }}>#3升降機</tr>
                                            <tr>
                                                <div style={{
                                                    fontSize: "24px",
                                                    overflow: "hidden",
                                                    fontWeight: "bold",
                                                    color: "#4caf50"
                                                }}>
                                                    <div
                                                        className="meterstatusstyle"
                                                        style={{
                                                            marginTop: "auto",
                                                            textAlign: "center",
                                                            fontWeight: "bold",
                                                            color: "#f5f0e9",
                                                            backgroundColor: "#1976d2",
                                                            borderRadius: "4px",
                                                            padding: "4px",
                                                            boxShadow: "none"
                                                        }}
                                                    >
                                                        {/*{device.status} kWh*/}
                                                        --- kWh
                                                    </div>
                                                </div>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td
                                    className="powermetercellstyle"
                                    style={{
                                        fontSize: "16px",
                                        overflow: "hidden",
                                        color: "#f7f4ef",
                                        backgroundColor: "#525252",
                                        transition: "all 0.3s ease",
                                        //border: isHovered ? "2px solid gold" : "2px solid transparent",
                                        borderRadius: "4px",
                                        padding: "8px",
                                        margin: "4px",
                                        boxShadow: "none"
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr style={{ fontSize: "22px", fontWeight: "bold", height: "78px" }}>#4升降機</tr>
                                            <tr>
                                                <div style={{
                                                    fontSize: "24px",
                                                    overflow: "hidden",
                                                    fontWeight: "bold",
                                                    color: "#4caf50"
                                                }}>
                                                    <div
                                                        className="meterstatusstyle"
                                                        style={{
                                                            marginTop: "auto",
                                                            textAlign: "center",
                                                            fontWeight: "bold",
                                                            color: "#f5f0e9",
                                                            backgroundColor: "#1976d2",
                                                            borderRadius: "4px",
                                                            padding: "4px",
                                                            boxShadow:  "none"
                                                        }}
                                                    >
                                                        {/*{device.status} kWh*/}
                                                        --- kWh
                                                    </div>
                                                </div>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </div>
                        </td>
                    </tr>


                </tbody>
            </table>
        );
    };

    return (
        <div className="containerstyle">
            <table>
                <tbody>
                    <tr>
                        <td style={{ verticalAlign: "top", width: "760px" }}>
                            <table style={{ verticalAlign: "top" }}>
                                <tbody>
                                    <tr>
                                        {!isLoading && (
                                            <div className="floorpin">
                                                <FloorplanImage src={groundFloor} alt="Ground Floor" />
                                                <ImageWithPins pins={pins_g} hoveredDeviceId={hoveredDeviceId} />
                                            </div>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1100px" }}>
                                <tbody>
                                    <DeviceList />
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}